import { lazy } from '@loadable/component';
import PropTypes from 'prop-types';
import React, { PureComponent, Suspense } from 'react';
import { ModalLoading } from './ModalLoading';

/**
 * For now, modals have to be default-exported to work with React lazy.
 * See https://github.com/facebook/react/issues/14603.
 * This might change in the future, and we'll revert back to named exports.
 */
const MODAL_COMPONENTS = {
  AnnouncementsModal: lazy(() => import('containers/Announcements/AnnouncementsModalContainer')),
  BillingTrustModal: lazy(() => import('features/Purchase/components/BillingTrustModal')),
  CancelReservationModal: lazy(() =>
    import('features/Reservation/CancelReservationModal/CancelReservationModalContainer')
  ),
  ClassBundleModal: lazy(() => import('features/Settings/Membership/Bundles/ClassBundleModalContainer')),
  CmsModal: lazy(() => import('components/CmsModals/CmsModal')),
  ContentModal: lazy(() => import('components/ModalHost/ContentModal')),
  DeviceSetupModal: lazy(() => import('containers/DeviceSetupModal/DeviceSetupModal')),
  InviteAFriendModal: lazy(() => import('components/Profile/InviteAFriendModal/InviteAFriendModalContainer')),
  LocaleModal: lazy(() => import('components/LocaleSwitcher/LocaleModal')),
  LocationModal: lazy(() => import('containers/LocationModal/Modal')),
  PlanConfirmationModal: lazy(() => import('features/Settings/Membership/Plans/PlanConfirmationModalContainer')),
  OfferModal: lazy(() => import('features/Offer/OfferModal/OfferModal')),
  ReactivationModal: lazy(() => import('features/Search/ReactivationModalContainer')),
  ReservationModal: lazy(() => import('features/Reservation/ReservationModal/ReservationModalContainer')),
  SaveOfferModal: lazy(() => import('features/Settings/Membership/SaveOfferModalContainer')),
  UpdateProfileModal: lazy(() => import('features/Reservation/UpdateProfileModal/UpdateProfileModal')),
  VideosRatingModal: lazy(() => import('features/Videos/VideosRatingModalContainer')),
  YouTubeVideoModal: lazy(() => import('containers/YouTubeVideoModal/Modal')),
};

export class ModalHost extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  handleModalClose() {
    const { onHideRequest, modalName } = this.props;
    onHideRequest(modalName);
  }

  render() {
    const { modalName, modalProps } = this.props;

    if (!modalName) {
      return null;
    }

    const ModalComponent = MODAL_COMPONENTS[modalName];

    if (!ModalComponent) {
      throw new Error(`Cannot find modal ${modalName}`);
    }

    return (
      <Suspense fallback={<ModalLoading />}>
        <ModalComponent onModalClose={this.handleModalClose} {...modalProps} />
      </Suspense>
    );
  }
}

ModalHost.propTypes = {
  modalName: PropTypes.string,
  modalProps: PropTypes.object,
  onHideRequest: PropTypes.func.isRequired,
};
